import { locationIdFormat } from "@redotech/redo-inventory-id";
import { productIdFormat } from "@redotech/redo-product-id";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const ProductLocationHistoryReferenceSchema = z.discriminatedUnion(
  "kind",
  [
    z.object({
      kind: z.literal("order"),
      fulfillmentGroupId: z.string(),
      orderId: z.string().nullable(),
      orderName: z.string().nullable(),
    }),
    z.object({ kind: z.literal("return"), returnId: z.string() }),
    z.object({ kind: z.literal("inboundShipment"), shipmentId: z.string() }),
  ],
);
export type ProductLocationHistoryReference = z.infer<
  typeof ProductLocationHistoryReferenceSchema
>;

const ProductLocationHistoryItemSchema_ = z.object({
  id: z.string(),
  source: createEnum(["movement", "commitment"]),
  kind: z.string(),
  description: z.string(),
  binDelta: z.number().nullable(),
  onHandDelta: z.number().nullable(),
  onHandAfter: z.number().nullable(),
  committedDelta: z.number().nullable(),
  committedBefore: z.number().nullable(),
  committedAfter: z.number().nullable(),
  balance: z.number().nullable(),
  storageLocationName: z.string().nullable(),
  storageLocationType: z.string().nullable(),
  lotNumber: z.string().nullable(),
  actor: z.string().nullable(),
  notes: z.string().nullable(),
  referenceId: z.string().nullable(),
  reference: ProductLocationHistoryReferenceSchema.nullable(),
  createdAt: z.string(),
});

export const ProductLocationHistoryItemSchema: z.ZodType<ProductLocationHistoryItem> =
  ProductLocationHistoryItemSchema_;
export interface ProductLocationHistoryItem extends z.infer<
  typeof ProductLocationHistoryItemSchema_
> {}

export const listProductLocationHistory = {
  name: "listProductLocationHistory" as const,
  input: z.object({
    productId: productIdFormat.schema,
    locationId: locationIdFormat.schema,
    sortDirection: createEnum(["asc", "desc"]).default("desc"),
    limit: z.number().default(50),
    offset: z.number().default(0),
  }),
  output: z.object({
    items: z.array(ProductLocationHistoryItemSchema),
    total: z.number(),
  }),
};
